"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PileIdHandler = void 0;
const helper_1 = require("../../../common/helper");
const logic_types_1 = require("../logic-types");
class PileIdHandler {
    static getStringFromPileId(pileId) {
        switch (pileId) {
            case logic_types_1.PileId.Deck:
                return "D";
            case logic_types_1.PileId.Croupier:
                return "C";
            case logic_types_1.PileId.Player1:
                return "P1";
            case logic_types_1.PileId.Player2:
                return "P2";
            case logic_types_1.PileId.Player3:
                return "P3";
            case logic_types_1.PileId.Player4:
                return "P4";
            case logic_types_1.PileId.Waste:
                return "W";
            default: {
                (0, helper_1.assertNever)(pileId, "Unknown pileId");
            }
        }
    }
    static getPileIDFromString(id) {
        switch (id) {
            case "D":
                return logic_types_1.PileId.Deck;
            case "C":
                return logic_types_1.PileId.Croupier;
            case "P1":
                return logic_types_1.PileId.Player1;
            case "P2":
                return logic_types_1.PileId.Player2;
            case "P3":
                return logic_types_1.PileId.Player3;
            case "P4":
                return logic_types_1.PileId.Player4;
            case "W":
                return logic_types_1.PileId.Waste;
            default:
                throw new Error(`Unknown pile id: ${id}`);
        }
    }
    static nextPlayerPileId(pileId) {
        switch (pileId) {
            case logic_types_1.PileId.Player1:
                return logic_types_1.PileId.Player2;
            case logic_types_1.PileId.Player2:
                return logic_types_1.PileId.Player3;
            case logic_types_1.PileId.Player3:
                return logic_types_1.PileId.Player4;
            case logic_types_1.PileId.Player4:
                return undefined;
            default: {
                return undefined;
            }
        }
    }
}
exports.PileIdHandler = PileIdHandler;
